module.exports = __webpack_public_path__ + "static/media/fa-brands-400.c1868c95.eot";